import { keyBy } from "lodash";

import { AccountCircle } from "@livechat/design-system-icons";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

import { IAgentFilterItem } from "./agent-filter";

const title = "Agent";
export const agentFilterConfigMultiple: IFilterConfig = {
  title,
  icon: AccountCircle,
  mobileViewTitle: "Select agents",
  multiple: true,
  getFilterLabelValues: (filterValues: string[] | null, agents: IAgentFilterItem[]): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    const agentsMap = keyBy(agents, agent => agent.id);
    return filterValues.reduce((acc: IFilterLabelValue[], agentEmail) => {
      if (agentsMap[agentEmail]) {
        return [...acc, { key: agentsMap[agentEmail].id, label: agentsMap[agentEmail].name }];
      }
      if (agentEmail === "ME") {
        return [...acc, { key: "ME", label: "Logged in agent" }];
      }
      return [...acc, { key: agentEmail, label: `${title} removed`, invalid: true }];
    }, []);
  },
};
